// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Contbank */
export const Contbank = createBankIcon({
  name: "Contbank",
  slug: "contbank",
  compe: null,
  color: "#ffffff",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#ffffff;fill-opacity:1\"\n     id=\"contbank_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(21.0241,21.0155) scale(0.02320)\">\n    <path d=\"M 2178.9,1573.74 s -146.15,237.68 -475.01,237.68 s -539.96,-258.16 -539.96,-561.43 s 211.12,-561.43 539.96,-561.43 c 292.31,0 450.65,204.9 450.65,204.9 l 336.97,-303.24 s -272.01,-360.63 -787.62,-360.63 c -397.35,0 -738.74,212.22 -912.56,531.96 L 194.74,761.55 l -65.7,328.98 l 551.69,0 c -7.95,51.84 -12.1,105.07 -12.1,159.46 s 4.2,107.59 12.25,159.48 L 65.33,1409.47 L -0.37,1738.45 l 792.67,0 c 174.12,318.61 515.01,531.96 911.6,531.96 c 519.66,0 795.73,-368.83 795.73,-368.83 l -320.73,-327.83 Z\" style=\"fill:#0d1124\" />\n  </g>",
});
